import { gql } from '@apollo/client';

/**
 * Query to fetch attributes with their values filtered by shop_id
 * Only returns attributes that are actually used by products in the shop
 */
export const GET_ATTRIBUTES = gql`
  query GetAttributes {
    mst_attributes {
      id
      name
    }
  }
`;

/**
 * Categories for a shop — merged from category_product links and visible products.
 */
export {
  GET_CATEGORIES_BY_LINK as GET_CATEGORIES,
  GET_CATEGORIES_BY_LINK,
  GET_SHOP_CATEGORIES,
} from '../services/categoryCatalogService';

/**
 * Query to fetch products with filters
 * Uses mst_product table from Hasura
 */
export const GET_PRODUCTS = gql`
  query GetProducts($limit: Int, $offset: Int, $shopId: uuid!) {
    mst_product(
      limit: $limit
      offset: $offset
      where: {
        shop_id: { _eq: $shopId }
        isdeleted: { _neq: true }
        visible: { _eq: true }
      }
      order_by: { created_at: desc }
    ) {
      id
      visible
      name
      description
      selling_price
      offered_price
      mrp_price
      base_price
      images
      stocks
      quantity
      category
      sub_category
      shop_id
      created_at
      product_code
      status
      top_selling
      trending_products
      mst_category {
        id
        category
      }
      mst_sub_category {
        id
        sub_name
      }
      attributes
      mst_product_variants(where: { isdeleted: { _neq: true } }) {
        id
        attributes
        price
        offered_price
        images
        mst_stock {
          stock_count
        }
      }
    }
  }
`;

/**
 * Query to fetch a single product by ID
 * Uses mst_product table from Hasura
 */
export const GET_PRODUCT_BY_ID = gql`
  query GetProductById($id: uuid!, $shopId: uuid!) {
    mst_product(
      where: {
        id: { _eq: $id }
        shop_id: { _eq: $shopId }
        isdeleted: { _neq: true }
        visible: { _eq: true }
      }
      limit: 1
    ) {
      id
      visible
      name
      description
      selling_price
      offered_price
      mrp_price
      base_price
      images
      stocks
      quantity
      category
      sub_category
      shop_id
      created_at
      product_code
      status
      bar_code
      show_stock
      top_selling
      trending_products
      mst_category {
        id
        category
      }
      mst_sub_category {
        id
        sub_name
      }
      attributes
      mst_product_variants(where: { isdeleted: { _neq: true } }) {
        id
        attributes
        price
        offered_price
        images
        mst_stock {
          stock_count
        }
      }
    }
  }
`;

export const GET_PRODUCTS_BY_IDS = gql`
  query GetProductsByIds($shopId: uuid!, $ids: [uuid!]!) {
    mst_product(
      where: {
        shop_id: { _eq: $shopId }
        id: { _in: $ids }
        isdeleted: { _neq: true }
        visible: { _eq: true }
      }
    ) {
      id
      visible
      name
      description
      selling_price
      offered_price
      mrp_price
      base_price
      images
      stocks
      quantity
      category
      sub_category
      shop_id
      created_at
      product_code
      status
      attributes
      mst_product_variants(where: { isdeleted: { _neq: true } }) {
        id
        attributes
        price
        offered_price
        images
        mst_stock {
          stock_count
        }
      }
    }
  }
`;

/**
 * Query to fetch products for a specific category
 */
export const GET_PRODUCTS_BY_CATEGORY = gql`
  query GetProductsByCategory(
    $shopId: uuid!
    $categoryId: uuid!
    $limit: Int = 8
  ) {
    mst_product(
      where: {
        shop_id: { _eq: $shopId }
        category: { _eq: $categoryId }
        isdeleted: { _neq: true }
        visible: { _eq: true }
      }
      limit: $limit
      order_by: { created_at: desc }
    ) {
      id
      visible
      name
      description
      selling_price
      offered_price
      mrp_price
      base_price
      images
      stocks
      quantity
      category
      sub_category
      shop_id
      created_at
      product_code
      status
      mst_category {
        id
        category
      }
      mst_product_variants(where: { isdeleted: { _neq: true } }) {
        id
        attributes
        price
        offered_price
        images
        mst_stock {
          stock_count
        }
      }
    }
  }
`;
